import React from 'react';

export const DepositCheckSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={52}
      height={52}
      fill='none'
    >
      <path
        fill='#55ACEE'
        stroke='#fff'
        strokeWidth={4}
        d='M10 26c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16ZM26 2C12.745 2 2 12.745 2 26s10.745 24 24 24 24-10.745 24-24S39.255 2 26 2Z'
      />
      <path
        stroke='#55ACEE'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M34.733 19.6 23 31.333 17.667 26'
      />
    </svg>
  );
};
